import { generatePath } from 'react-router';
import { RememberMeSettings } from '@Constants/rx-user/constants';
import Auth from '@Services/Auth';
import Login from '@Services/Login';
import { loginLimitErrorType } from '@Pages/LoginLimit/LoginLimitConstants';
import history from '@AppRoutes/history';
import { paths } from '@AppRoutes/constants';
import { organizationSetIsLoadingReducerType } from './OrganizationConstants';
import { isLoading as isLoadingSelector } from './OrganizationSelectors';

export function setIsLoading(isLoading) {
  return {
    type: organizationSetIsLoadingReducerType,
    payload: { isLoading },
  };
}

export const login = (chosenPath, response) => async (dispatch, getState) => {
  const isLoading = isLoadingSelector(getState());

  if (isLoading) {
    return;
  }

  const data = {
    aeAuthToken: response.data.authToken,
    chosenPath,
    remember_me_token: response.data[RememberMeSettings.token],
    rememberChoice: !!response.data[RememberMeSettings.token],
    grant_type: 'choice',
  };
  dispatch(setIsLoading(true));
  await Auth.login({}, data)
    .then(Login.afterAuthRedirect)
    .catch((error) => {
      if (
        !(
          error.type === 'CONFIRM' ||
          error.type === 'RELOGIN' ||
          error.type === loginLimitErrorType ||
          error.type === 'EXTERNAL' ||
          error.type === 'ERROR_RETRY'
        )
      ) {
        history.push({
          pathname: generatePath(paths.LOGIN),
          state: {
            loginFail: error.message,
          },
        });
      }
    })
    .finally(() => {
      dispatch(setIsLoading(false));
    });
};

export const goToLoginPage = () => {
  history.push({
    pathname: generatePath(paths.LOGIN),
  });
};
